import * as React from "react";

import classNames from "classnames";

export const switchModes = {
  ON: "ON",
  OFF: "OFF",
  MIXED: "MIXED",
} as const;

export type SwitchMode = keyof typeof switchModes

interface GenSwithProps {
  value: SwitchMode;
  onClick: (mode: SwitchMode) => void;
  includeMixed?: boolean;
}

export default function GenSwitch(
  {
    value,
    onClick,
    includeMixed,
  }: GenSwithProps,
) {
  return (
    <span
      className="gen-switch"
      onClick={(e) => {
          e.stopPropagation();
          switch (value) {
            case switchModes.ON:
              onClick(switchModes.OFF);
              break;
            case switchModes.OFF:
              onClick(includeMixed ? switchModes.MIXED : switchModes.ON);
              break;
            case switchModes.MIXED:
            default:
              onClick(switchModes.ON);
          }}}
    >
      <span className={classNames("gen-switch-slider", `${value}`)}  />
    </span>
  );
}
